export const CLICK_OPEN_MENU = 'CLICK_OPEN_MENU';
